import $ from 'jquery';

class Minimenus {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Section menu
        $(document).ready(() => {
            if ($('.menu-container--not-hero').length) {
                $('.menu-container--not-hero').prepend($('<button class="btn accent-btn js-toggle-side-menu hide-desktop" type="button">Section Menu <span class="icon-angle-down"></span></button>'));
                $('.js-toggle-side-menu').click((e) => {
                    $('.menu-container').toggle();
                    $(e.currentTarget).toggleClass('active');
                });
            }

            if ($('.sbts.relocate-minimenu.menu-container--not-hero').length) {
                $('.sbts.relocate-minimenu.menu-container--not-hero').appendTo('.promo-hero');
            }

            if ($('.sbts.resources.menu-container--not-hero').length) {
                $('aside.side-menu.js-side-menu').clone().appendTo('.sbts.resources.menu-container--not-hero .menu-container .menu-item:nth-last-child(2)');
            }

            if ($('.sbts.stories.menu-container--not-hero').length) {
                $('aside.side-menu.js-side-menu').clone().appendTo('.sbts.stories.menu-container--not-hero .menu-container .menu-item:nth-last-child(3)');
            }

            if ($('.mini-menu-tab').length) {
                $('.mini-menu-tab a').click((e) => {
                    $('.mini-menu-tab').removeClass('active');
                    $(e.currentTarget).closest('.mini-menu-tab').addClass('active');
                    $(e.currentTarget).closest('.mini-menu-tab').addClass('active');
                });
            }

            // talkaboutvaping.com:  on mobile, the "Section Menu" jump menu appears. When a link is clicked, the accordions below with the matching ID will be clicked and thus open.
            $('#main .js-nav-megamenu a').addClass('jumpMenuLink');

            $('.jumpMenuLink').on('click', (e) => {
                if (window.innerWidth < 768) {
                    let href = e.target.getAttribute('href').substring(1);
                    if (document.getElementById(href).children[0] !== undefined) {
                        document.getElementById(href).children[0].click();
                    }
                }
            });

            // hiding two of three accordion dropdowns on load. they will appear after user interaction, or on mobile
            // console.log('"Why is vaping dangerous" and "What is behind the epidemic" are hidden via javascript via minimenus.js and not css so that they are accessible in the CMS which will hide them if done with css.');

            // get the facts 2nd and 3rd hide
            if (document.URL.includes('/talk-about-vaping/vaping-facts')) {
                document.getElementById('GROUP-why-is-vaping-dangerous').style.display = 'none';
                document.getElementById('GROUP-what-is-behind-the-epidemic').style.display = 'none';

                // conversation page desktop: clicking tabs shows/hides sections
                $('.before-you-talk').on('click', () => {
                    // section 1 hide
                    document.getElementById('GROUP-what-is-vaping').style.display = 'block';
                    //section 2 show
                    document.getElementById('GROUP-why-is-vaping-dangerous').style.display = 'none';
                    //section 3 hide
                    document.getElementById('GROUP-what-is-behind-the-epidemic').style.display = 'none';
                });
                $('.while-youre-talking').on('click', () => {
                    // section 1 hide
                    document.getElementById('GROUP-what-is-vaping').style.display = 'none';
                    //section 2 show
                    document.getElementById('GROUP-why-is-vaping-dangerous').style.display = 'block';
                    //section 3 hide
                    document.getElementById('GROUP-what-is-behind-the-epidemic').style.display = 'none';
                });
                $('.after-you-talk').on('click', () => {
                    // section 1 hide
                    document.getElementById('GROUP-what-is-vaping').style.display = 'none';
                    //section 2 hide
                    document.getElementById('GROUP-why-is-vaping-dangerous').style.display = 'none';
                    //section 3 show
                    document.getElementById('GROUP-what-is-behind-the-epidemic').style.display = 'block';
                });

                // top menu scrolling for Get The Facts
                const scrollWhatIsVaping = () => {
                    $('html, body').animate({ scrollTop: $('#GROUP-what-is-vaping').offset().top }, 1000);
                };
                $('.topMenuWhatIsVaping').on('click', () => {
                    if ($('.what-is-vaping a').attr('href') === '#what-is-vaping') {
                        $('.what-is-vaping a').click();
                        $('.header-toggle').click();
                        setTimeout(scrollWhatIsVaping, 250);
                    }
                });

                const scrollWhyIsVaping = () => {
                    $('html, body').animate({ scrollTop: $('#GROUP-why-is-vaping-dangerous').offset().top }, 1000);
                };
                $('.topMenuWhyIsVapingDangerous').on('click', () => {
                    if ($('.why-is-vaping-dangerous a').attr('href') === '#why-is-vaping-dangerous') {
                        $('.why-is-vaping-dangerous a').click();
                        $('.header-toggle').click();
                        setTimeout(scrollWhyIsVaping, 250);
                    }
                });

                const scrollWhatIsBehind = () => {
                    $('html, body').animate({ scrollTop: $('#GROUP-what-is-behind-the-epidemic').offset().top }, 1000);
                };
                $('.topMenuWhatIsBehindTheEpidemic').on('click', () => {
                    if ($('.what-is-behind-the-epidemic a').attr('href') === '#what-is-behind-the-epidemic') {
                        $('.what-is-behind-the-epidemic a').click();
                        $('.header-toggle').click();
                        setTimeout(scrollWhatIsBehind, 250);
                    }
                });
            } else if (document.URL.includes('/talk-about-vaping/conversation-guide')) {
                // conversation 2nd and 3rd hide
                document.getElementById('GROUP-while-youre-talking').style.display = 'none';
                document.getElementById('GROUP-after-you-talk').style.display = 'none';
                // conversation 1st active
                document.getElementsByClassName('before-you-talk')[0].classList.add('active');

                // conversation page desktop: clicking tabs shows/hides sections
                $('.before-you-talk').on('click', () => {
                    // section 1 hide
                    document.getElementById('GROUP-before-you-talk').style.display = 'block';
                    //section 2 show
                    document.getElementById('GROUP-while-youre-talking').style.display = 'none';
                    //section 3 hide
                    document.getElementById('GROUP-after-you-talk').style.display = 'none';
                });
                $('.while-youre-talking').on('click', () => {
                    // section 1 hide
                    document.getElementById('GROUP-before-you-talk').style.display = 'none';
                    //section 2 show
                    document.getElementById('GROUP-while-youre-talking').style.display = 'block';
                    //section 3 hide
                    document.getElementById('GROUP-after-you-talk').style.display = 'none';
                });
                $('.after-you-talk').on('click', () => {
                    // section 1 hide
                    document.getElementById('GROUP-before-you-talk').style.display = 'none';
                    //section 2 hide
                    document.getElementById('GROUP-while-youre-talking').style.display = 'none';
                    //section 3 show
                    document.getElementById('GROUP-after-you-talk').style.display = 'block';
                });

                // CONVERSATION TOP MENU SCROLLS
                const scrollBeforeYouTalk = () => {
                    $('html, body').animate({ scrollTop: $('#GROUP-before-you-talk').offset().top }, 1000);
                };
                $('.topMenuBeforeYouTalk').on('click', () => {
                    if ($('.before-you-talk a').attr('href') === '#before-you-talk') {
                        $('.before-you-talk a').click();
                        $('.header-toggle').click();
                        setTimeout(scrollBeforeYouTalk, 250);
                    }
                });

                const scrollWhileYoureTalking = () => {
                    $('html, body').animate({ scrollTop: $('#GROUP-while-youre-talking').offset().top }, 1000);
                };
                $('.topMenuWhileYoureTalking').on('click', () => {
                    if ($('.while-youre-talking a').attr('href') === '#while-youre-talking') {
                        $('.while-youre-talking a').click();
                        $('.header-toggle').click();
                        setTimeout(scrollWhileYoureTalking, 250);
                    }
                });

                const scrollAfterYouTalk = () => {
                    $('html, body').animate({ scrollTop: $('#GROUP-after-you-talk').offset().top }, 1000);
                };
                $('.topMenuAfterYouTalk').on('click', () => {
                    if ($('.after-you-talk a').attr('href') === '#after-you-talk') {
                        $('.after-you-talk a').click();
                        $('.header-toggle').click();
                        setTimeout(scrollAfterYouTalk, 250);
                    }
                });
            }

            // creating way for page to scroll to anchor in link automatically on load
            const scrollOnLoad = (anchorName) => {
                let anchorNameId = `#${anchorName}`;
                //let anchorNameClass = `.${anchorName} a`;
                $('html, body').animate({ scrollTop: $(anchorNameId).offset().top }, 1000);
            };
            // creating way for page to automatically open anchor in link
            const openAccordionOnLoad = (tabName, anchorName) => {
                $(`.${tabName} a`).click();
                if (window.innerWidth > 768) {
                    $(`#${anchorName}`).children().click();
                }
                setTimeout(scrollOnLoad, 1000, anchorName);
            };
            const accordionDuration = 1000;
            let loadUrl = document.URL;
            if (loadUrl.split('#').length > 1) {
                let anchorName = loadUrl.split('#')[1];
                if (loadUrl.includes('vaping-facts')) {
                    if (anchorName === 'what-is-vaping' || anchorName === 'why-is-vaping-dangerous' || anchorName === 'what-is-behind-the-epidemic') {
                        //let anchorNameId = `#${anchorName}`;
                        //let anchorNameClass = `.${anchorName} a`;
                        $(`.${anchorName} a`).click();
                        //setTimeout(scrollOnLoad, 1000, `.${anchorName} a`, `#${anchorName}`);
                        setTimeout(scrollOnLoad, 1000, anchorName);
                    } else { 
                        let tabName;
                        switch (anchorName) {
                            //what is vaping
                            case 'flavored-water-vapor':
                                tabName = 'what-is-vaping';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'are-vape-and-ecigarettes-the-same':
                                tabName = 'what-is-vaping';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'what-do-devices-look-like':
                                tabName = 'what-is-vaping';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'signs-of-use':
                                tabName = 'what-is-vaping';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            // why is vaping dangerous
                            case 'why-should-i-be-concerned':
                                tabName = 'why-is-vaping-dangerous';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'what-makes-it-addictive':
                                tabName = 'why-is-vaping-dangerous';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'why-is-nicotine-so-harmful':
                                tabName = 'why-is-vaping-dangerous';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'why-are-kids-trying-it':
                                tabName = 'why-is-vaping-dangerous';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            // what is behind the epidemic
                            case 'how-many-kids-are-vaping':
                                tabName = 'what-is-behind-the-epidemic';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'is-the-trend-growing':
                                tabName = 'what-is-behind-the-epidemic';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'is-there-regulation':
                                tabName = 'what-is-behind-the-epidemic';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'what-is-big-tobaccos-involvement':
                                tabName = 'what-is-behind-the-epidemic';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            default:
                                // error
                        }
                    }
                } else if (loadUrl.includes('conversation-guide')) {
                    // IF IT IS A TAB ANCHOR
                    if (anchorName === 'before-you-talk' || anchorName === 'while-youre-talking' || anchorName === 'after-you-talk') {
                        //let anchorNameId = `#${anchorName}`;
                        //let anchorNameClass = `.${anchorName} a`;
                        $(`.${anchorName} a`).click();
                        //setTimeout(scrollOnLoad, 1000, `.${anchorName} a`, `#${anchorName}`);
                        setTimeout(scrollOnLoad, 1000, anchorName);
                    } else {
                        // IF IT IS AN ACCORDION ANCHOR
                        let tabName;
                        switch (anchorName) { 
                            // before-you-talk
                            case 'what-is-big-tobaccos-involvement':
                                tabName = 'know-the-facts';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'put-yourself-in-your-childs-shoes':
                                tabName = 'before-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'take-an-open-and-calm-approach':
                                tabName = 'before-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'find-the-right-time-and-place':
                                tabName = 'before-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'take-time-to-practice':
                                tabName = 'before-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            // while you talk
                            case 'acknowledge-your-childs-independence':
                                tabName = 'while-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'ask-for-their-perspective':
                                tabName = 'while-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'be-ready-to-hear-that-your-child-may-have-vaped':
                                tabName = 'while-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'blame-big-tobacco-not-your-kid':
                                tabName = 'while-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'avoid-scare-tactics':
                                tabName = 'while-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'connect-with-what-they-care-about':
                                tabName = 'while-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            // after-you-talk
                            case 'say-thank-you':
                                tabName = 'after-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'help-your-child-manage-stress':
                                tabName = 'after-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'help-your-child-manage-peer-pressure':
                                tabName = 'after-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'follow-up':
                                tabName = 'after-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'stay-up-to-date':
                                tabName = 'after-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            case 'share-this-information':
                                tabName = 'after-you-talk';
                                setTimeout(openAccordionOnLoad, accordionDuration, tabName, anchorName);
                                break;
                            default:
                                //
                        }
                    }
                }
            }

            $('.menu-item a').on('click', (e) => {
                if (window.innerWidth >= 768) {
                    let x = window.pageXOffset;
                    let y = window.pageYOffset;
                    $(window).one('scroll', () => {
                        window.scrollTo(x, y);
                    });
                }
            });

            $('.next-btn').on('click', (e) => {
                //console.log(e.currentTarget);
                let href = e.currentTarget.getAttribute('href');
                let anchorName = href.split('#')[1];
                if (href.includes('#')) {
                    href = `.${href.substring(1, href.length)} a`;
                    $(href).click();
                    //$('body').css('background', 'blue');
                    //document.getElementsByClassName(href)[0].click();
                }
                setTimeout(scrollOnLoad, 500, anchorName);
            });

            $('.previous-btn').on('click', (e) => {
                //console.log(e.currentTarget);
                let href = e.currentTarget.getAttribute('href');
                let anchorName = href.split('#')[1];
                if (href.includes('#')) {
                    href = `.${href.substring(1, href.length)} a`;
                    $(href).click();
                    //$('body').css('background', 'blue');
                    //document.getElementsByClassName(href)[0].click();
                }
                setTimeout(scrollOnLoad, 500, anchorName);
            });
        });
    }
}

export default Minimenus;